var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdobeIllustrator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    "data-name": "Layer 1",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Photo Surface"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 232,
    x: 8,
    y: 12,
    fill: "#300",
    "data-name": "Outline no shadow",
    rx: 42
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9a00",
    d: "M128.79 156H93l-9.24 26.68Q83.6 184 82.09 184H65.29q-1.68 0-1.17-1.65L96.54 86.06A29.5 29.5 0 0097.88 77a.89.89 0 011-1H122.4c.68 0 1.07.28 1.18.82l36.28 105.7c.34 1 .06 1.48-.84 1.48H140.21a1.74 1.74 0 01-1.68-1zM97 138h27.88c-.67-1.47-13.21-41.93-14.11-45.34h-.16zM179.91 96a11.81 11.81 0 01-8.61-3.21 11.55 11.55 0 01-3.3-8.7 11.71 11.71 0 013.39-8.79 12 12 0 018.7-3.3 11.55 11.55 0 018.7 3.3A12.07 12.07 0 01192 84.09a11.55 11.55 0 01-3.3 8.7A12.07 12.07 0 01179.91 96zM170 182.5V105.34a1.18 1.18 0 011.34-1.34h17.32a1.19 1.19 0 011.34 1.34v77.32a1.18 1.18 0 01-1.34 1.34H171.5A1.33 1.33 0 01170 182.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeIllustrator);
export default __webpack_public_path__ + "static/media/adobe-illustrator.6b24fbb994e3bbf85fd324b3f042a532.svg";
export { ForwardRef as ReactComponent };